import * as React from 'react';
import SecondaryToolbar from '../common/SecondaryToolbar';
import IconButton from '../common/IconButton';
import { ToolbarDirection } from '../../actions/UIModeAction';
import { connect } from 'react-redux';
import { SpeechState, TTSStatus } from '../../tts/reducers/speech';
import { AppStates } from '../../reducers/app';
import { TTSContext } from '../app/App';
import { SecondaryToolbarType } from '../header-toolbar/NewHeaderToolbar';

interface TTSSettingSecondaryLevelProps {
  readonly direction: ToolbarDirection;
  readonly speech: SpeechState;
  readonly setSecondaryToolbarType: (secondaryToolbarType: SecondaryToolbarType) => void;
}

// NOTE : min/max restriction might be better to be extracted to outside of this component.
const MIN_RATE = 1;
const MAX_RATE = 100;

const TTSSettingSecondaryLevel: React.SFC<
  TTSSettingSecondaryLevelProps
> = React.memo((props) => {
  const { rate, status } = props.speech;
  const enablePlay = (status !== TTSStatus.Playing);
  const enablePause = (status === TTSStatus.Playing);
  const enableReset = (status !== TTSStatus.Idle);
  const enableRate = (status === TTSStatus.Idle);

  return (
    <TTSContext.Consumer>{(context) => {
      return (
        <SecondaryToolbar direction={props.direction}>
          <IconButton
            title="再生"
            imagePath="images/tool-icons/new/regeneration/regeneration"
            disabled={!enablePlay}
            onClick={() => {
              if (status === TTSStatus.Paused) {
                context.onResume();
              } else {
                context.onPlay();
              }
            }} />
          <IconButton
            title="一時停止"
            imagePath="images/tool-icons/new/pause/pause"
            disabled={!enablePause}
            onClick={() => {
              if (status === TTSStatus.Paused) {
                context.onResume();
              } else {
                context.onPause();
              }
            }} />
          <IconButton
            title="停止"
            imagePath="images/tool-icons/new/stop/stop"
            disabled={!enableReset}
            onClick={context.onReset} />
          <IconButton
            disabled={true}
            title="前に戻る(準備中) 読み上げ位置を戻します。"
            imagePath="images/tool-icons/new/back/back" />
          <IconButton
            disabled={true}
            title="次に進む(準備中) 読み上げ位置を進めます。"
            imagePath="images/tool-icons/new/forward/forward" />
          <IconButton
            title="スピード＋"
            imagePath="images/tool-icons/new/read_speed_plus/read_speed_plus"
            disabled={!enableRate}
            onClick={() => context.onRateChange(Math.min(MAX_RATE, rate + 1))} />
          <IconButton
            title="スピードー"
            imagePath="images/tool-icons/new/read_speed_minus/read_speed_minus"
            disabled={!enableRate}
            onClick={() => context.onRateChange(Math.min(MIN_RATE, rate - 1))} />
          <IconButton
            disabled={true}
            title="話者切り替え(準備中)　読み上げ時の音声を変更します。"
            imagePath="images/tool-icons/new/talker_switching/talker_switching" />
          <IconButton
            title="戻る"
            imagePath="images/tool-icons/new/btn_return/btn_return"
            rouondRect={true}
            onClick={() => props.setSecondaryToolbarType(SecondaryToolbarType.None)} />
        </SecondaryToolbar>
      );
    }}</TTSContext.Consumer>
  );
});

const mapStateToProps = (appStates: AppStates) => ({
  speech: appStates.speech,
});

export default connect(mapStateToProps)(TTSSettingSecondaryLevel);
